/* eslint-disable */
import { WebSocketClient } from 'utils/webSocketClient';
import { cacheKey } from 'appConstants';
import { cache } from 'utils/cache';

const getTokenCallback = () => cache.get(cacheKey.REAL_TIME_TICKET_ID);

let wsURL = process.env.REACT_APP_REAL_TIME;

export const setWsUrlToEU = () => {
  wsURL = 'wss://rt-aws-eu.prd.textrecruit.tools/chat';
};

let ws = null;

const connectRealtime = ({ onOpenCallback, onMessageCallback }) => {
  if (ws === null) {
    ws = new WebSocketClient(wsURL);
  }
  ws.connect(getTokenCallback, onOpenCallback, onMessageCallback);
};

// https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent
const normalCloseCode = 4001;

export const Realtime = {
  connect: connectRealtime,
  disconnect: () => ws?.close(normalCloseCode),
};
